import React, { useState, useEffect } from 'react'
import NavBar from './components/NavBar'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import './app.css'
import ShowCase from './components/ShowCase'
import SignIn from './components/SignInUp/SignIn'
import SignUp from './components/SignInUp/SignUp'
import firebase from 'firebase'
import User from './components/UserComp/User'
import WelcomePage from './components/WecomePage'
import AdminView from './components/AdminView'
export const UserContext = React.createContext(null)

function App() {
    const [CurrentUser, setCurrentUser] = useState(null)
    useEffect(() => {
        let isSubscribed = true;
        firebase.auth().onAuthStateChanged(user => {
            if (isSubscribed) {
                setCurrentUser(user)
            }
        })
        return () => { isSubscribed = false }
    })
    useEffect(
        () => {
            setTimeout(() => { }, 1000)

        }, [CurrentUser]
    )
    return (
        <>
            {CurrentUser === null ?
                <div>
                    <Router>
                        <NavBar isInNoUserPage={true} />
                        <Route exact path='/'>
                            <WelcomePage />
                        </Route>
                        <Route exact path='/signin'>
                            <SignIn />
                        </Route>
                        <Route exact path='/signup'>
                            <SignUp />
                        </Route>
                        <Route path='/:name'>
                            {/* <ShowCase /> */}
                        </Route>
                    </Router>
                </div>
                :
                <UserContext.Provider value={CurrentUser}>
                    <Router>
                        <NavBar isInNoUserPage={false} />
                        <div className='container'>
                            <Switch>
                                <Route exact path='/' >
                                    <Redirect to='/admin' />
                                </Route>
                                <Route exact path='/admin'>
                                    <AdminView />
                                </Route>
                                <Route exact path='/signin'>
                                    <SignIn />
                                </Route>
                                <Route exact path='/signup'>
                                    <SignUp />
                                </Route>
                                <Route exact path='/user'>
                                    <User />
                                </Route>
                                <Route exact path='/:name'>
                                    <ShowCase />
                                </Route>
                            </Switch>
                        </div>
                    </Router>
                </UserContext.Provider>
            }
        </>



    )
}

export default App
